
import React from "react";
import styled, { createGlobalStyle } from "styled-components";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Settings from "../components/Settings";

import { getUserInfo } from "../components/Helper";
import { spacing } from "@mui/system";
import {
  Box,
  CssBaseline,
  Paper as MuiPaper,
  useMediaQuery,
  useTheme
} from "@mui/material";

const drawerWidth = 239;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.body.background};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${props => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${props => props.theme.body.background};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

class Dashboard extends React.Component {
  state = {
      mobileOpen: false,
      userInfo: getUserInfo()
  };

    handleDrawerToggle = () => {
        this.setState(state => ({
            mobileOpen: !state.mobileOpen
        }));
    };

  render() {
      const { children, routes, isLg, isMobile } = this.props;

    return (
      <Root>
        <CssBaseline />
        <GlobalStyle />
        <Drawer>
          {isMobile && (
            <Sidebar
              routes={routes}
              slotProps={{ paper: { style: { width: drawerWidth } } }}
              variant="temporary"
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              userinfo={this.state.userInfo}
            />
          )}
        <Box sx={theme => ({ [theme.breakpoints.down("md")]: { display: "none" } })}>
            <Sidebar
                routes={routes}
                slotProps={{ paper: { style: { width: drawerWidth } } }}
                userinfo={this.state.userInfo}
            />
        </Box>
        </Drawer>
        <AppContent>
          <Header onDrawerToggle={this.handleDrawerToggle} userInfo={this.state.userInfo}/>
          <MainContent p={isLg ? 10 : 5}>
            {children}
          </MainContent>
          <Footer />
        </AppContent>
        <Settings />
      </Root>
    );
  }
}

function DashboardWithWidth(props) {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  return <Dashboard {...props} isLg={isLg} isMobile={isMobile} />;
}

export default DashboardWithWidth;
